import * as React from "react"
import { cn } from "../../../lib/utils"
import { getAvatarColor, getInitials } from "../../../lib/avatar-color"
import { Avatar, AvatarFallback, AvatarImage } from "../avatar/avatar"

const sizeClasses = {
  sm: "size-6 text-[10px]",
  md: "size-8 text-xs",
  lg: "size-10 text-sm",
  xl: "size-20 text-xl",
} as const

export interface UserAvatarProps
  extends Omit<React.ComponentProps<"span">, "children"> {
  /** Display name or email — drives initials and background color */
  name: string
  /** Avatar size preset */
  size?: "sm" | "md" | "lg" | "xl"
  /** Optional photo URL — shown instead of initials, falls back to initials on error */
  src?: string | null
}

function UserAvatar({
  name,
  size = "md",
  src,
  className,
  style,
  ...props
}: UserAvatarProps) {
  const initials = getInitials(name)
  const backgroundColor = getAvatarColor(name)

  return (
    <Avatar className={cn(sizeClasses[size], className)}>
      {src && <AvatarImage src={src} alt={name} referrerPolicy="no-referrer" />}
      <AvatarFallback
        data-slot="user-avatar"
        className={cn("font-medium", sizeClasses[size])}
        style={{
          backgroundColor,
          color: "hsl(0, 0%, 25%)",
          ...style,
        }}
        {...props}
      >
        {initials}
      </AvatarFallback>
    </Avatar>
  )
}

export { UserAvatar }
